import {AppState} from "../store";
import {toTransportMethod} from "@ots-frontend/ots-data";

export const getInsightsFilter = (state: AppState) => state.insights.filter
export const getInsightsHaulMethod = (state: AppState) => state.insights.haulMethod ? toTransportMethod(state.insights.haulMethod) : undefined
export const getInsightsDisposalCostType = (state: AppState) => state.insights.disposalCostType
export const getInsightsRateModel = (state: AppState) => state.insights.rateModel
